import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64 } from "@/utils";

export default async function (data) {
  const node = data.node;
  const catalogueList = node.list || node.children;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style=\"text-align: left;\"><span style=\"font-size: 24.49px;font-family: Microsoft Yahei;\">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme, "theme");
  const ex1 = await getThemePic(data?.customTheme, "ex-1");

  return {
    id: id,
    elements: [
      {
        type: "image",
        id: "ZSOBNhS0yU",
        src: ex1,
        width: 1000,
        height: 562.5,
        left: 0,
        top: 0,
        fixedRatio: true,
        rotate: 0,
        flipH: false,
        flipV: false,
      },
      {
        type: "text",
        id: "tnlnL9uAvG",
        width: 234.30667461263408,
        height: 44.484375,
        left: 122.37666269368296,
        top: 322.0333373063171,
        rotate: 90,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        content:
          '<p style=""><span style="font-size: 24.49px;"><span style="font-family: 微软雅黑;"><span style="color: rgba(240,233,233,1);">CONTENTS</span></span></span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "YInNmuq8ed",
        width: 292.3460667461263,
        height: 117.953125,
        left: 118.88,
        top: 230.28,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        content:
          '<p style=""><span style="font-size: 97.96px;"><span style="font-family: 方正正大黑简体;"><span style="color: rgba(238,232,232,1);">目&nbsp;录</span></span></span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "shape",
        id: "ujrFAiwad-",
        width: 25.4,
        height: 209.55,
        left: 31.75,
        top: -76.19999999999999,
        viewBox: [25.4, 209.55],
        path: "M 3.175 0 L 22.224999999999998 0 Q 25.4 0 25.4 3.175 L 25.4 206.375 Q 25.4 209.55 22.224999999999998 209.55 L 3.175 209.55 Q 0 209.55 0 206.375 L 0 3.175 Q 0 0 3.175 0 Z",
        fill: "#4f81bd",
        fixedRatio: false,
        rotate: 33,
        outline: {
          color: "#254061",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: Calibri;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
        pathFormula: "roundRect",
        keypoint: 0.125,
      },
      {
        type: "shape",
        id: "ozcizq_ueg",
        width: 12.7,
        height: 209.55,
        left: 38.099999999999994,
        top: -12.709999999999994,
        viewBox: [12.7, 209.55],
        path: "M 1.5875 0 L 11.112499999999999 0 Q 12.7 0 12.7 1.5875 L 12.7 207.9625 Q 12.7 209.55 11.112499999999999 209.55 L 1.5875 209.55 Q 0 209.55 0 207.9625 L 0 1.5875 Q 0 0 1.5875 0 Z",
        fill: "#4f81bd",
        fixedRatio: false,
        rotate: 33,
        outline: {
          color: "#254061",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: Calibri;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
        pathFormula: "roundRect",
        keypoint: 0.125,
      },
      {
        type: "shape",
        id: "qPC4dfREHv",
        width: 25.4,
        height: 298.45,
        left: 901.16,
        top: 336.3,
        viewBox: [25.4, 298.45],
        path: "M 3.175 0 L 22.224999999999998 0 Q 25.4 0 25.4 3.175 L 25.4 295.275 Q 25.4 298.45 22.224999999999998 298.45 L 3.175 298.45 Q 0 298.45 0 295.275 L 0 3.175 Q 0 0 3.175 0 Z",
        fill: "#4f81bd",
        fixedRatio: false,
        rotate: 33,
        outline: {
          color: "#254061",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: Calibri;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
        pathFormula: "roundRect",
        keypoint: 0.125,
      },
      {
        type: "shape",
        id: "xRCy2J52nC",
        width: 12.7,
        height: 209.55,
        left: 907.51,
        top: 450.6,
        viewBox: [12.7, 209.55],
        path: "M 1.5875 0 L 11.112499999999999 0 Q 12.7 0 12.7 1.5875 L 12.7 207.9625 Q 12.7 209.55 11.112499999999999 209.55 L 1.5875 209.55 Q 0 209.55 0 207.9625 L 0 1.5875 Q 0 0 1.5875 0 Z",
        fill: "#4f81bd",
        fixedRatio: false,
        rotate: 33,
        outline: {
          color: "#254061",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: center;"><span style="font-size: 18.37px;font-family: Calibri;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "middle",
        },
        flipH: false,
        flipV: false,
        pathFormula: "roundRect",
        keypoint: 0.125,
      },
      {
        type: "line",
        id: "RWfciRQRl0",
        width: 1.5,
        left: 394.48,
        top: 135.16,
        start: [0, 0],
        end: [0, 313.23],
        style: "dashed",
        color: "#4F81BD",
        points: ["", ""],
      },
      {
        type: "text",
        id: "FKQsx5EgLg",
        left: 493.4541792547834,
        top: 137.23308734055047,
        width: 361.664988251091,
        height: 241.921875,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#fff",
        vertical: false,
      },
    ],

    background,
  };
}
